import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "./auth/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import LogoIntro from "./components/LogoIntro";
import Home from "./pages/Home";
import AvailableHomes from "./pages/AvailableHomes";
import HomeDetail from "./pages/HomeDetail";
import CustomHomes from "./pages/CustomHomes";
import OurWork from "./pages/OurWork";
import OurProcess from "./pages/OurProcess";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Testimonial from "./pages/Testimonial";
import Reviews from "./pages/Reviews";
import CityPage from "./pages/CityPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

const useLenis = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
};

const Shell = () => {
  useLenis();
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <div className="min-h-screen bg-[#F7F5F2]">
      <div className="noise-overlay" aria-hidden="true" />
      {!isAdmin && <Navbar />}
      {!isAdmin && <LogoIntro />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/available-homes" element={<AvailableHomes />} />
        <Route path="/available-homes/:id" element={<HomeDetail />} />
        <Route path="/custom-homes" element={<CustomHomes />} />
        <Route path="/our-work" element={<OurWork />} />
        <Route path="/our-process" element={<OurProcess />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/testimonial" element={<Testimonial />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/areas/:slug" element={<CityPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <BackToTop />}
      <Toaster position="bottom-right" />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
